export const LOAD = 'LOAD_FLOOD_CONTROL';
export const LOAD_START = `${LOAD}_START`;
export const LOAD_SUCCESS = `${LOAD}_SUCCESS`;
export const LOAD_FAIL = `${LOAD}_FAIL`;

export const SAVE = 'SAVE_FLOOD_CONTROL';
export const SAVE_START = `${SAVE}_START`;
export const SAVE_SUCCESS = `${SAVE}_SUCCESS`;
export const SAVE_FAIL = `${SAVE}_FAIL`;

const uri = '/webapi/xm/1/notification-filters';

const defaultPayloadValues = {
  filterType: 'NOTIFICATION_FLOOD_CONTROL',
  active: true,
};

export function load() {
  return {
    type: LOAD,
    meta: {
      xmApi: true,
      method: 'get',
      uri,
    },
  };
}

export function save(config) {
  const payload = {
    ...defaultPayloadValues,
    config,
  };
  return {
    type: SAVE,
    meta: {
      xmApi: true,
      method: 'post',
      uri,
      params: payload,
    },
  };
}

export function update(id, config) {
  const payload = {
    ...defaultPayloadValues,
    id,
    config,
  };
  return {
    type: SAVE,
    meta: {
      xmApi: true,
      method: 'post',
      uri,
      params: payload,
    },
  };
}
